import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import {
  IBriefInfluencerSearchRequestV2,
  IGetBriefInfluencersV2Response,
} from "@shared/lib/types/briefInfluencerV2";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useGetBriefInfluencersV2Paginated(
  params: IBriefInfluencerSearchRequestV2,
  enabled = true
) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<IGetBriefInfluencersV2Response>
  >({
    queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "paginated", params],
    queryFn: () => BriefService.getBriefInfluencersV2(params),
    enabled: enabled && Boolean(params.briefId),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    briefInfluencers: data?.data?.data ?? [],
    totalCount: data?.data?.pagination?.totalCount ?? 0,
    isFetching: isLoading,
    isError,
    refetch,
  };
}
